export const menuList = {
	main: {
		id: 1,
		category: "Main dishes",
		background: "3",
		menuContent: [
			{
				id: 1,
				food_name: "Soft shell crab",
				description:
					"Granny help you treat yourself with a different meal everyday",
				price: 29,
			},
			{
				id: 2,
				food_name: "Pork Egg Rolls",
				description: "Ground shrimp, taro, carrots, and mushrooms",
				price: 10,
			},
			{
				id: 3,
				food_name: "Empanadas",
				description: "Two fried turnovers stuffed with spicy ground beef",
				price: 7,
			},
			{
				id: 4,
				food_name: "Crab Stuffed Shrimp",
				description:
					"Three jumbo shrimp stuffed with crab meat and served over a pepper jelly",
				price: 12,
			},
		],
	},
	starter: {
		id: 2,
		category: "Starter",
		background: "15",
		menuContent: [
			{
				id: 5,
				food_name: "Provoleta",
				description:
					"Grilled provolone cheese topped with tomato and sprinkled with oregano",
				price: 19,
			},
			{
				id: 6,
				food_name: "Caprese",
				description:
					"Traditional Italian salad with fresh mozzarella, tomato and basil drizzled with olive oil and a balsamic reduction",
				price: 25,
			},
			{
				id: 7,
				food_name: "Filet Mignon",
				description: "8 oz. served in a creamy peppercorn sauce",
				price: 35,
			},
			{
				id: 8,
				food_name: "Cowboy Rib-eye",
				description: "32 oz. bone-in",
				price: 45,
			},
		],
	},
	desserts: {
		id: 3,
		category: "Desserts",
		background: "1",
		menuContent: [
			{
				id: 9,
				food_name: "Tiramisu",
				description: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
				price: 15,
			},
			{
				id: 10,
				food_name: "Dulce de Leche Crêpe ",
				description: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
				price: 15,
			},
			{
				id: 11,
				food_name: "New York Cheesecake",
				description: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
				price: 15,
			},
			{
				id: 12,
				food_name: "Chocolate Soufflé ",
				description: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
				price: 20,
			},
		],
	},
	seafood: {
		id: 4,
		category: "Sea Food",
		background: "16",
		menuContent: [
			{
				id: 13,
				food_name: "Blackend Cajun Salmon",
				description:
					"6 oz. blackened salmon fillet grilled to perfection. Served with your choice of two sides.",
				price: 40,
			},
			{
				id: 14,
				food_name: "Double Crunch Shrimp",
				description: "Breaded shrimp, cocktail sauce, slaw and fries.",
				price: 35,
			},
			{
				id: 15,
				food_name: "Lobster with melted mozarella",
				description:
					"5 pounds lobster grilled with top-classed mozarella cheese",
				price: 25,
			},
		],
	},
	drinks: {
		id: 5,
		category: " Drinks",
		background: "17",
		menuContent: [
			{
				id: 16,
				food_name: "Charles de Fere",
				description: "France",
				price: 80,
			},
			{
				id: 17,
				food_name: "Canyon Road Pinot Grigio ’09",
				description: "California",
				price: 125,
			},
			{
				id: 18,
				food_name: "Crane Lake White Zinfandet ’09",
				description: "Napa Valley California",
				price: 195,
			},
			{
				id: 19,
				food_name: "Luigi Bosca Reserva Cabernet Sauvignon ’07",
				description: "Argentina",
				price: 199,
			},
		],
	},
};
